let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g48Pz")).then(() => parcelRequire('9XolH'));